
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.815,"time":48900,"words":163}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Brushing Room is the service location where footmen are trained to serve as valets when staffing is inadequate. This allows players to use white footman meeples as if they were green valet meeples when providing service to gentlemen guests.`}</p>
    <div className="flavor-text">
      <p>{`The Brushing Room was a small place in a superior house for brushing garments. There, a male servant experienced with providing personal service to the gentlemen of the house (butler, underbutler, valet) could educate a footman being called upon in a time of need on the proper care of a wardrobe.`}</p>
    </div>
    <p>{`The Brushing Room service tile appears randomly in the builders’ market and has a discount of £200 attached to the purchase price. When a player acquires this tile, it is placed under SERVICE in the country estate organiser. On all future turns, the player may use a footman as a valet when providing service to a gentleman, but only when a valet is unavailable.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Brushing Room"
}

